export const APP_UPDATE = 'APP_UPDATE';

export const appUpdate = payload => {
    return {
        type: APP_UPDATE,
        payload,
    };
};
